/**
 * Created by lihanying on 2017/7/10.
 */
import React from 'react'
import { DatePicker, Radio, Select, Button, message, Spin, Input } from 'antd'
import moment from 'moment'
import Report from './report'
const { RangePicker } = DatePicker
const Option = Select.Option
const Search = Input.Search
const ALL = 0

export default class extends React.Component {
  state = {
    size: '4',
    visible: false,
    record_type: '0',
    commodity_id: '',
    search_name: '',
    loading: false,
  }

  componentDidMount() {
    this.props.fetchTimePeriod(this.state.size) //默认值
  }

  onChange = (value, dateString) => {
    if (value.length > 0) {
      this.props.getPeriod({
        start_time: dateString[0],
        end_time: dateString[1],
      })
    } else {
      this.props.getPeriod({ start_time: null, end_time: null }) //清除
    }
  }

  handleSizeChange = (e) => {
    this.setState({ size: e.target.value })
    this.props.fetchTimePeriod(e.target.value) //时间范围
  }

  handleChange = (value) => {
    this.setState({ record_type: value })
  }

  handleButton = () => {
    const { record_type, search_name } = this.state
    let a
    if (record_type.length > 0) {
      if (record_type === '1') {
        a = '1' //普通商品
      } else if (record_type === '2') {
        a = '2' //非普通商品
      } else {
        a = '' //所有商品
      }
      let data = {
        start_time: this.props.period.start_time || '',
        end_time: this.props.period.end_time || '',
        commodity_type: this.state.commodity_id,
        commodity_name: search_name,
        standard_type: a,
      }
      this.props.fetchMarketScaleList(
        Object.assign({}, data, { need_detail: true })
      )
      this.setState({ loading: true })
      this.props.fetchMarketList(data).then((res) => {
        this.setState({ loading: false })
      })
    } else {
      message.info('请选择一个商品分组')
    }
  }

  render() {
    const { size } = this.state
    const {
      marketType,
      period,
      marketList,
      marketRecord,
      marketScaleList,
      incomeSum,
    } = this.props
    return (
      <div>
        <div className="business">
          <div className="business-left">
            <Radio.Group
              value={size}
              onChange={this.handleSizeChange}
              style={{ display: 'block', marginBottom: '1rem' }}
            >
              <Radio.Button value="1">昨日</Radio.Button>
              <Radio.Button value="2">今日</Radio.Button>
              <Radio.Button value="3">上月</Radio.Button>
              <Radio.Button value="4">本月</Radio.Button>
              <Radio.Button value="5">去年</Radio.Button>
              <Radio.Button value="6">今年</Radio.Button>
            </Radio.Group>
            <div>
              <span style={{ marginRight: '.5rem' }}>时间</span>
              <RangePicker
                format="YYYY-MM-DD"
                placeholder={['开始时间', '结束时间']}
                value={
                  period.start_time
                    ? [
                        moment(`${period.start_time}`, 'YYYY-MM-DD'),
                        moment(`${period.end_time}`, 'YYYY-MM-DD'),
                      ]
                    : null
                }
                onChange={this.onChange}
              />
            </div>
            <div>
              <span style={{ marginRight: '.5rem' }}>分组</span>
              <Select
                defaultValue="0"
                style={{ width: 200, marginTop: '1rem' }}
                placeholder="选择商品分组"
                onChange={this.handleChange}
              >
                <Option value="0">全部</Option>
                <Option value="1">普通商品</Option>
                <Option value="2">非普通商品</Option>
              </Select>
            </div>
            <div>
              <span style={{ marginRight: '.5rem' }}>分类</span>
              <Select
                defaultValue=""
                style={{ width: 200, marginTop: '1rem' }}
                placeholder="选择商品分类,可不选择"
                onChange={(value) => this.setState({ commodity_id: value })}
              >
                <Option value="">全部</Option>
                {marketType.list &&
                  marketType.list.map((item, idx) => {
                    return (
                      <Option value={item.id} key={idx}>
                        {item.name}
                      </Option>
                    )
                  })}
              </Select>
            </div>
            <div style={{ marginTop: '1rem' }}>
              <Button type="primary" onClick={() => this.handleButton('2')}>
                显示
              </Button>
            </div>
          </div>
          <div className="business-left">
            <Search
              placeholder="请输入商品名称搜索商品"
              style={{ width: 300, marginBottom: '1rem' }}
              onChange={(e) => this.setState({ search_name: e.target.value })}
              onSearch={this.handleButton}
            />
          </div>
        </div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Report
            period={period}
            scaleList={marketScaleList}
            list={marketList}
            marketRecord={marketRecord}
            fetchMarketRecord={this.props.fetchMarketRecord}
            sum={incomeSum}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubMarket/component/market.js